import { RootState } from "integrations/redux"
import { checklistDetailsSliceName } from "./slice"
import { createSelector } from "@reduxjs/toolkit"

const root = (s: RootState) => s[checklistDetailsSliceName]

export const selectChecklistDetailsTab = createSelector([root], (s) => s.tab)
export const selectChecklistDateFilter = createSelector([root], (s) => s.dateFilter)
export const selectChecklistPilotFilter = createSelector([root], (s) => s.pilotFilter)
